import { Container } from "@mui/material";
import bgImage from "assets/images/bg-desktop.jpg";
import HomePageLayout from "layouts/components/HomePageLayout";
import MainSection from "layouts/reusable/MainSection";
import { pricingMainContent } from "static/homepage/data";

export const Pricing = () => {
    const { topic, content, image } = pricingMainContent

    return (
        <HomePageLayout
            bgColor={"inherit"}
            image={bgImage}
            pageName="Pricing"
            coverHeight=""
            heroText=""
        >

            <Container>
                <MainSection topic={topic} content={content} image={image} />
            </Container>


        </HomePageLayout>
    );
}

